import styled from "styled-components";

export interface IAboutMeTextProps {
  mobile: boolean;
}

export const StyledAboutMeText = styled.div`

  width: 52%;
  max-width: 600px;
  max-height: 50vh;
  @media screen and (max-width:768px) {
    max-height: none;
  }
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  p {
    margin-bottom: 0.9rem;
    font-size: 14px;
  }

  @media screen and (max-width: 768px) {
    width: 90%;
    margin-top: 50px;
    margin-left: 20px;
    gap: 50px;
  }

`;